export default "__VITE_ASSET__1f6c03ec__"